module.exports = __webpack_public_path__ + "media/Take Me Away.fa6a8623.mp3";